
import layout from '@/layouts/layout-pay.vue'

export default [
  {
    path: '/pay',
    redirect: '/pay',
    component: layout,
    /* hidden: true, */
    children: [{
      path: '/',
      name: 'pay',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/pay.vue')), 'pay'),
      meta: { title: '支付页', icon: '' }
    }, {
      path: '/applyrefund/:id',
      name: 'applyrefund',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/applyRefund.vue')), 'applyrefund'),
      meta: { title: '申请退款页', icon: '' }
    }, {
      path: '/paydetail',
      name: 'paydetail',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/payDetail.vue')), 'paydetail'),
      meta: { title: '支付详情页', icon: '' }
    }, {
      path: '/refunddetail/:id',
      name: 'refunddetail',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/refundDetail.vue')), 'refunddetail'),
      meta: { title: '退款详情页', icon: '' }
    }, {
      path: '/refunding',
      name: 'refunding',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/refunding.vue')), 'refunding'),
      meta: { title: '退款中', icon: '' }
    }, {
      path: '/refundreject',
      name: 'refundreject',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/refundRejectDetail/refundRejectDetail.vue')), 'refundRejectDetail'),
      meta: { title: '退款驳回详情页', icon: '' }
    }, {
      path: '/payorder',
      name: 'payorder',
      component: resolve => require.ensure([], () => resolve(require('@/views/pay/payOrder.vue')), 'payorder'),
      meta: { title: '订单列表页', icon: '' }
    }]
  }
]
